import { Role } from '../enums/role.enum';

export const USER_SITE_ADMIN = {
  firstName: 'Brent',
  lastName: 'Werbeck',
  id: '123456789',
  email: 'brent@getmorereviews.com',
  createdAt: 1571846584612,
  updatedAt: 1571846584612,
  lastLogin: 1571846584612,
  role: {
    id: '5db07941bade501e6f5bac5c',
    name: Role.SiteAdmin,
    shortName: "SPRAD",
    labelName: 'Site Admin',
    createdAt: 1571846464952,
    updatedAt: 1571846464952,
    deletedAt: 1571846464952,
    deleted: false,
  },
  permissions: [
    "createContact",
    "createBusiness",
    "createLocation",
    "sendReviewRequest",
    "viewReviewTargets",
    "viewResellers",
    "viewBusinesses",
    "switchToBusinessAdmin",
    "viewSiteAdminConfiguration",
    "viewResellersConfiguration",
    "viewBusinessConfiguration",
    "viewLocationConfiguration",
    "editMaxQuota",
    "editRemovePowered",
    "editeAvailableLicensesReseller"
  ]
}

export const USER_RESELLER_ADMIN = {
  firstName: 'Food',
  lastName: 'Reviews',
  id: '123456789',
  email: 'reseller@freviews.com',
  createdAt: 1571846584612,
  updatedAt: 1571846584612,
  lastLogin: 1571846584612,
  role: {
    id: '5db07941bade501e6f5bac5c',
    name: Role.Reseller,
    shortName: "SPRAD",
    labelName: 'Reseller Admin',
    createdAt: 1571846464952,
    updatedAt: 1571846464952,
    deletedAt: 1571846464952,
    deleted: false,
  },
  permissions: [
    "createContact",
    "createBusiness",
    "createLocation",
    "sendReviewRequest",
    "viewReviewTargets",
    "viewResellers",
    "viewBusinesses",
    "switchToBusinessAdmin",
    "viewResellersConfiguration",
    "viewBusinessConfiguration",
    "viewLocationConfiguration"
  ]
}

export const USER_BUSINESS_ADMIN = {
  firstName: 'John',
  lastName: 'Doe',
  id: '987654321',
  email: 'jdoe@mcdonalds.com',
  createdAt: 1571846584612,
  updatedAt: 1571846584612,
  lastLogin: 1571846584612,
  role: {
    id: '5db079b8bade501e6f5bac5f',
    name: Role.BusinessAdmin,
    shortName: "BSUSR",
    labelName: 'Multilocation Business Admin',
    createdAt: 1571846584612,
    updatedAt: 1571846584612,
    deletedAt: 1571846584612,
    deleted: false
  },
  permissions: [
    "viewDashboard",
    "viewReviews",
    "viewBusinessProfile",
    "viewBusinessConfiguration",
    "viewLocationConfiguration"
  ]
}

export const USER_BUSINESS = {
  firstName: 'Dave',
  lastName: 'Bking',
  id: '987654321',
  email: 'dave@bking.com',
  createdAt: 1571846584612,
  updatedAt: 1571846584612,
  lastLogin: 1571846584612,
  role: {
    id: '5db079b8bade501e6f5bac5f',
    name: Role.UserBusiness,
    shortName: "BSUSR",
    labelName: 'Single Location Business User',
    createdAt: 1571846584612,
    updatedAt: 1571846584612,
    deletedAt: 1571846584612,
    deleted: false
  },
  permissions: [
    "viewDashboard",
    "viewReviews",
    "viewBusinessProfile",
    "onlyOneLocation",
    "viewLocationConfiguration"
  ]
}



export const ADDRESSES = [
  'Summerlin, Las Vegas, NV, USA',
  '1299-1203 E 125th St, Los Angeles, CA 90059, USA',
  '398-350 Eddie Dr, Vista, CA 92083, USA',
  'Fruitvale Station, Oakland, CA 94601, USA',
  '38 Otis St, San Francisco, CA 94103, USA',
  '2550-2698 S 740 E, Salt Lake City, UT 84106, USA',
  '1125 17th Street, Denver, CO 80202, USA',
  '1601 McGee St, Kansas City, MO 64108, USA',
  'Lake Cherokee, Orlando, FL 32801, USA',
  '1775 I St NW, Washington, DC 20006, USA',
  '83 Peachtree St SW, Atlanta, GA 30303, USA',
  '16402-16252 Vicki Dr, Oklahoma City, OK 73170, USA',
  'Camelback East Village, Phoenix, AZ 85008, USA',
  '2461 4th Ave S, Seattle, WA 98134, USA',
  '1129-601 Higley Rd, Lapeer, MI 48446, USA',
  '301-399 Hazeldine Ave SW, Albuquerque, NM 87102, USA',
];
